import type { AssetId } from 'owa-timestream-types';
import getStore from './store';

export function isResizing(assetId?: AssetId) {
    const store = getStore();
    if (!!assetId) {
        return assetId === store.assetResizing;
    }

    return !!getStore().assetResizing;
}

export function isResizeHandlesShown() {
    return getStore().shouldShowResizeHandles;
}

export function getAssetResizingParent() {
    return getStore().assetResizingParent;
}

export function getResizingAsset() {
    return getStore().assetResizing;
}
